import {useEffect, useContext} from 'react'
import {ReservationContext} from '../../../context/Reservation'
import {snap} from '../../../utils/ApMath'
import moment from 'moment'

const useMonthReserveAction = (date, weekCount = 4) => {
  const {update, setPopReserve} = useContext(ReservationContext)
  useEffect(() => {
    const ref = document.querySelector('[data-x="month-reserve"]')
    const refNewEventItems = document.querySelectorAll('.event-item--new')
    const refScroller = document.querySelector('.month-scroller')

    let reserveOnOrAfter = moment()
      .add(1, 'day')
      .startOf('day')

    // private variables
    let columnWidth = 0
    let rowHeight = 130
    let initX = 0
    let initY = 0
    let initScrollY = 0
    let startX = 0
    let startY = 0

    let indexStartX = 0
    let indexEndX = 0
    let indexStartY = 0
    let indexEndY = 0

    let scrollOffsetY = 0
    let offsetY = 0
    let offsetX = 0

    let hasStarted = false
    let dateSelected = false

    // dates
    let start = null
    let end = null

    const handleMouseDown = e => {
      let rect = ref.getBoundingClientRect()

      initX = e.clientX
      startX = initX - rect.left
      hasStarted = true
      columnWidth = rect.width / 7

      initY = e.clientY
      initScrollY = ref.scrollTop
      scrollOffsetY = 0
      startY = e.clientY - rect.top
    }

    const handleMouseUp = e => {
      if (dateSelected) {
        dateSelected = false
        update('date_from', start)
        update('date_to', end)
        setPopReserve(true)
      }
      hasStarted = false
      refNewEventItems.forEach((ref, i) => {
        ref.style.display = 'none'
      })
    }

    const handleMove = () => {
      const snapStartY = snap(startY + initScrollY, rowHeight, Math.floor)
      indexStartY = Math.max(0, snapStartY / rowHeight)

      const snapEndY = snap(startY + offsetY + scrollOffsetY + initScrollY, rowHeight, Math.floor)
      indexEndY = Math.max(Math.min(weekCount, snapEndY / rowHeight), indexStartY)

      const snapStartX = snap(startX, columnWidth, Math.floor)
      indexStartX = Math.max(0, snapStartX / columnWidth)

      const snapEndX = snap(startX + offsetX, columnWidth, Math.floor)
      indexEndX = Math.max(
        Math.min(6, snapEndX / columnWidth),
        indexStartY === indexEndY ? indexStartX : 0
      )

      start = date
        .clone()
        .add(indexStartY * 7 + indexStartX, 'days')
        .startOf('day')
        .set('hour', 8)
      end = date
        .clone()
        .add(indexEndY * 7 + indexEndX, 'days')
        .set('hour', 18)

      // check if start date is on or before limit
      if (start.valueOf() >= reserveOnOrAfter.valueOf()) {
        dateSelected = true

        refNewEventItems.forEach((ref, i) => {
          if (i >= indexStartY && i <= indexEndY) {
            ref.style.display = 'flex'
            ref.style.left = i === indexStartY ? `${indexStartX * columnWidth}px` : '0px'
            ref.style.right = i === indexEndY ? `${(6 - indexEndX) * columnWidth}px` : '0px'
            ref.textContent = `${start.format('MM/DD')} - ${end.format('MM/DD')}`
          } else {
            ref.style.display = 'none'
          }
        })
      }
    }
    const handleMouseMove = e => {
      if (!hasStarted) return
      offsetY = e.clientY - initY
      offsetX = e.clientX - initX
      handleMove(offsetY + scrollOffsetY)
    }

    const handleScroll = e => {
      if (!hasStarted) return
      scrollOffsetY = refScroller.scrollTop - initScrollY
      handleMove(offsetY + scrollOffsetY)
    }

    refScroller.addEventListener('scroll', handleScroll)
    ref.addEventListener('mousedown', handleMouseDown)
    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)

    return () => {
      ref.removeEventListener('mousedown', handleMouseDown)
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [date, weekCount, update, setPopReserve])
}

export default useMonthReserveAction
